import type { ChartData } from '@shared/ui/charts'

export const checkDataExist = (data: ChartData[]) =>
  data.length > 0 && data.some(d => d.series.some(s => s.data.length > 0))
